import { React, useEffect } from "react";
import { sendPostRequest } from "../../Client/index.js";
import { useParams, useNavigate } from "react-router-dom";

export default function Fixture({}) {
  const navigate = useNavigate();

  const { validation } = useParams();

  const validate = async () => {
    const res = await sendPostRequest("user-auth/validation", {
      validation: validation,
    });

    if (!res.token) {
      navigate(`/login`);
    }

    localStorage.setItem("ballerz-user", JSON.stringify(res));

    if (res.users.length === 0) {
      navigate(`/no-user`, { state: { email: res.email } });
    } else if (res.users.length > 1) {
      navigate(`/select-user`);
    } else {
      navigate(`/`);
    }
  };

  useEffect(() => {
    validate();
  }, [validation]);

  return <></>;
}
